import type { App } from 'vue';
import FFullPageLayout from './f-full-page-layout.vue';

export declare interface FullPage {
  install: (app: App) => void;
}

export function useFullPage() : FullPage {
  return {
    install: (app: App) => {
      app.component('FFullPageLayout', FFullPageLayout);
    },
  };
}